import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Draggable } from '@hello-pangea/dnd';
import { IssuePriorityIcon2 } from 'components';
import Grid from '@mui/material/Grid2';
import LocationCityIcon from '@mui/icons-material/LocationCity';

import {
  IssueLink,
  Issue,
  KanbanItemTitle,
  Bottom,
  IssueTitle,
  IssueProperty,
} from './Styles';

import { IssuePropTypes } from 'shared/propTypes/issueType';
import CaseStatsChips from './caseStatsChips';
import { IssueStatusKenshin } from 'shared/constants/kenshin/issues';

const propTypes = {
  issue: PropTypes.shape(IssuePropTypes).isRequired,
  index: PropTypes.number.isRequired,
};

const ProjectBoardListIssue = ({ issue, index }) => {
  const { pathname } = useLocation();
  console.log('Navigating to Issue Details Kenshin');
  console.log('pathname', pathname);

  return (
    <Draggable draggableId={issue.id.toString()} index={index}>
      {(provided, snapshot) => (
        <IssueLink
          to={`${pathname}/issues/${issue.id}`}
          state={{ trigger: 'byClick' }}
          ref={provided.innerRef}
          data-testid="list-issue"
          {...provided.draggableProps}
          {...provided.dragHandleProps}>
          <Issue
            status={issue.progress === IssueStatusKenshin.DONE}
            color={'blue'}
            isBeingDragged={snapshot.isDragging && !snapshot.isDropAnimating}>
            <KanbanItemTitle>
              <Grid container>
                <Grid size={12}>
                  <IssueTitle>
                    <p
                      style={{ fontWeight: 'bold' }}
                      data-testid="kanban-kenshin-issue-title">
                      {issue.title}
                    </p>
                  </IssueTitle>
                </Grid>
                <Grid size={12}>
                  <IssueProperty>
                    <LocationCityIcon
                      fontSize="medium"
                      sx={{ margin: '0 3px' }}
                    />
                    <p>{issue.srcOrgName}</p>
                  </IssueProperty>
                </Grid>
              </Grid>
            </KanbanItemTitle>

            <Bottom>
              <div>
                <IssuePriorityIcon2 priority={issue.priority} />
              </div>
            </Bottom>
            <Bottom>
              {issue.progress !== 'DONE' && <CaseStatsChips issue={issue} />}
            </Bottom>
          </Issue>
        </IssueLink>
      )}
    </Draggable>
  );
};

ProjectBoardListIssue.propTypes = propTypes;

export default ProjectBoardListIssue;
